import styled from "styled-components";

export const LoginInfo = styled.div`
  background-color: var(--pmbChestnut);
  color: white;
  width: 325px;
  padding: 12px;
  margin-bottom: 20px;
`;
